<template>
    <form class="form" autoComplete="off" :id=formName :name=formName noValidate="" method="POST">
        <div class="form-group">
            <label for="inputSignupName">{{ labelName }}</label>
            <input type="text" class="form-control" id="inputSignupName" placeholder="" />
        </div>
        <div class="form-group">
            <label for="inputSignupEmail">{{ labelEmail }}</label>
            <input type="email" class="form-control" id="inputSignupEmail" placeholder="Email" required="" />
        </div>
        <div class="form-group">
            <label for="inputSignupPassword">{{ labelPassword }}</label>
            <input type="password" class="form-control" id="inputSignupPassword" placeholder="Password" required="" />
        </div>
        <div class="form-group">
            <label for="inputSignupVerify">{{ labelVerifyPassword }}</label>
            <input type="password" class="form-control" id="inputSignupVerify" placeholder="Password (again)" required="" />
        </div>
        <div class="form-group">
            <button type="submit" class="btn btn-primary btn-lg float-right">{{ submitBtnText }}</button>
        </div>
    </form>
</template>
<script>
export default {
    props: {
        formName: 'formSignup',
        labelName: 'Name',
        labelEmail: 'Email',
        labelPassword: 'Password',
        labelVerifyPassword: 'Verify',
        submitBtnText: {
            type: String,
            default: "Submit"            
        }
    }
};
</script>
